import { Component, OnInit } from '@angular/core';
import { moduloRPlus } from '../../diccionarios/RPlusModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { RPlusService } from '../../services/rplus.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-ejecutar-procesos',
  templateUrl: './ejecutar-procesos.component.html',
  styleUrls: ['./ejecutar-procesos.component.css']
})
export class EjecutarProcesosComponent implements OnInit {

  public DAT_TITULOS: any = moduloRPlus.titulos.ejecucionDeProcesos;
  public DAT_BTNS: any = moduloRPlus.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloRPlus.button.buttonsCss;
  public DAT_AG_GRID: any = moduloRPlus.agGrid;
  public DAT_MSG: any = moduloRPlus.mensajes;

  public loading: boolean = false;

  public agregarForm = new FormGroup({
    descarga_partes: new FormControl(false),
    envio_partes: new FormControl(false),
    envio_inventario: new FormControl(false),
    envio_demandas: new FormControl(false),
    envio_supply: new FormControl(false),
    envio_formulas: new FormControl(false),
    envio_consumos: new FormControl(false),
    envio_workorders: new FormControl(false),
    envio_calendario_mmto: new FormControl(false),
  });

  processTotal = 0;
  processFinish = 0;
  processOnDemandFinish = true;
  processDemandAllFinish = true;
  processOnDemandError = "";
  processDemandAllError = "";

  public programacionLoading: boolean = false;
  programacionTotal = 0;
  programacionFinish = 0;
  programacionError = "";

  constructor(
    private _util: UtilsService,
    private rplusService: RPlusService
  ) {
  }

  ngOnInit() {
  }

  ejecutarProcesos() {

    this.disableInputs();
    this.processTotal = 0;
    if (this.agregarForm.get("descarga_partes").value) this.processTotal++;

    let array = [];
    if (this.agregarForm.get("envio_partes").value) array.push('Parte');
    if (this.agregarForm.get("envio_inventario").value) array.push('Inventario');
    if (this.agregarForm.get("envio_demandas").value) array.push('Orden demanda');
    if (this.agregarForm.get("envio_supply").value) array.push('Ordenes de suministro');
    if (this.agregarForm.get("envio_formulas").value) array.push('Lista de materiales');
    if (this.agregarForm.get("envio_consumos").value) array.push('Historial de demanda');

    if (array.length > 0) this.processTotal++;

    if (this.processTotal == 0) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.processFinish = 0;

    if (this.agregarForm.get("descarga_partes").value) {
      this.processOnDemandFinish = false;
      this.rplusService.onDemand().subscribe(
        (resp) => {
          this.processFinish++;
          this.processOnDemandFinish = true;
          if (this.processFinish >= this.processTotal) {
            this.loading = false;
            this.enableInputs();
          }
        },
        (error) => {
          this.processFinish++;
          this.processOnDemandFinish = true;
          this.processOnDemandError = JSON.stringify(error, null, 4);
          if (this.processFinish >= this.processTotal) {
            this.loading = false;
            this.enableInputs();
          }
        }
      );
    }
    console.log("this.processFinish", this.processFinish)

    const payload = {
      'user': localStorage.getItem('userName'),
      'nameFiles': array
    }
    console.log("this.processFinish", this.processFinish)
    if (array.length > 0) {
      this.processDemandAllFinish = false;
      this.rplusService.demandAll(payload).subscribe(
        (resp) => {
          this.processFinish++;
          this.processDemandAllFinish = true;
          if (this.processFinish >= this.processTotal) {
            this.loading = false;
            this.enableInputs();
          }
        },
        (error) => {
          this.processFinish++;
          this.processDemandAllFinish = true;
          this.processDemandAllError = JSON.stringify(error, null, 4);
          if (this.processFinish >= this.processTotal) {
            this.loading = false;
            this.enableInputs();
          }
        }
      );
    }
  }

  disableInputs() {
    this.agregarForm.get('descarga_partes').disable();
    this.agregarForm.get('envio_partes').disable();
    this.agregarForm.get('envio_inventario').disable();
    this.agregarForm.get('envio_demandas').disable();
    this.agregarForm.get('envio_supply').disable();
    this.agregarForm.get('envio_formulas').disable();
    this.agregarForm.get('envio_consumos').disable();
  }

  enableInputs() {
    this.agregarForm.get('descarga_partes').enable();
    this.agregarForm.get('envio_partes').enable();
    this.agregarForm.get('envio_inventario').enable();
    this.agregarForm.get('envio_demandas').enable();
    this.agregarForm.get('envio_supply').enable();
    this.agregarForm.get('envio_formulas').enable();
    this.agregarForm.get('envio_consumos').enable();
  }

  ejecutarProgramacion() {
    this.disableProgramacionInputs();
    this.programacionTotal = 0;
    this.programacionError = "";

    const workorders = this.agregarForm.get('envio_workorders').value;
    const calendario = this.agregarForm.get('envio_calendario_mmto').value;

    if (workorders) this.programacionTotal++;
    if (calendario) this.programacionTotal++;

    if (this.programacionTotal == 0) {
      this.programacionLoading = false;
      this.enableProgramacionInputs();
      return;
    }

    this.programacionLoading = true;
    this.programacionFinish = 0;

    if (workorders) {
      // Mismo llamado que 'Envío Supply'
      const payload = {
        'user': localStorage.getItem('userName'),
        'nameFiles': ['Ordenes de suministro WO']
      };
      this.rplusService.demandAll(payload).subscribe(
        () => {
          this.programacionFinish++;
          this.checkProgramacionFinish();
        },
        (error) => {
          this.programacionFinish++;
          this.programacionError = JSON.stringify(error, null, 4);
          this.checkProgramacionFinish();
        }
      );
    }

    if (calendario) {
      console.log("ejecutando");
      this.programacionFinish++;
      this.checkProgramacionFinish();
    }
  }

  private checkProgramacionFinish() {
    if (this.programacionFinish >= this.programacionTotal) {
      this.programacionLoading = false;
      this.enableProgramacionInputs();
    }
  }

  disableProgramacionInputs() {
    this.agregarForm.get('envio_workorders').disable();
    this.agregarForm.get('envio_calendario_mmto').disable();
  }

  enableProgramacionInputs() {
    this.agregarForm.get('envio_workorders').enable();
    this.agregarForm.get('envio_calendario_mmto').enable();
  }

}
